import { padTo2Digits } from './padTo2Digits';

export const formatMMSS = (totalSeconds: number) => {
  const minutes = Math.max(0, Math.floor(totalSeconds / 60));

  const seconds = Math.round(totalSeconds % 60);
  return `${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;
};
